const formData = {
  formId: "shortTermJobOrderForm",
  formField: {
    fillByDate: {
      name: "fillByDate",
      label: "Date",
      requiredErrorMessage: "Date is required.",
    },
    onsigner: {
      name: "onsigner",
      label: "Mariner Name",
      requiredErrorMessage: "Mariner is required",
    },
    rating: {
      name: "rating",
      label: "Rating",
      requiredErrorMessage: "Rating is required.",
    },
    port: {
      name: "port",
      label: "Port",
      requiredErrorMessage: "Port is required.",
    },
  },
};

export default formData;
